import React from 'react';

// Glyphes de la police Astro Gadget : a = Bélier ... l = Poissons
const ZODIAC_GLYPHS = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l'];

// Roue zodiacale décorative (SVG pur, rotation lente en CSS)
const ZodiacWheel = ({ className }) => {
    const spokes = ZODIAC_GLYPHS.map((_, i) => {
        const angle = (i * 30 * Math.PI) / 180;
        return {
            x1: 200 + 140 * Math.cos(angle),
            y1: 200 + 140 * Math.sin(angle),
            x2: 200 + 192 * Math.cos(angle),
            y2: 200 + 192 * Math.sin(angle),
        };
    });
    const glyphs = ZODIAC_GLYPHS.map((glyph, i) => {
        const angle = ((i * 30 + 15) * Math.PI) / 180;
        return {
            glyph,
            x: 200 + 166 * Math.cos(angle),
            y: 200 + 166 * Math.sin(angle),
        };
    });

    return (
        <svg className={className} viewBox="0 0 400 400" aria-hidden="true" focusable="false">
            <g fill="none" stroke="currentColor">
                <circle cx="200" cy="200" r="192" strokeWidth="1.2" />
                <circle cx="200" cy="200" r="140" strokeWidth="0.8" />
                <circle cx="200" cy="200" r="96" strokeWidth="0.6" strokeDasharray="3 8" />
                <circle cx="200" cy="200" r="40" strokeWidth="0.6" />
                {spokes.map((s, i) => (
                    <line key={i} x1={s.x1} y1={s.y1} x2={s.x2} y2={s.y2} strokeWidth="0.8" />
                ))}
            </g>
            <g fill="currentColor" stroke="none">
                {glyphs.map((g, i) => (
                    <text
                        key={i}
                        x={g.x}
                        y={g.y}
                        textAnchor="middle"
                        dominantBaseline="central"
                        fontFamily="'Astro Gadget', sans-serif"
                        fontSize="24"
                        transform={`rotate(${i * 30 + 105} ${g.x} ${g.y})`}
                    >
                        {g.glyph}
                    </text>
                ))}
            </g>
        </svg>
    );
};

export default ZodiacWheel;
